export default "__VITE_ASSET__DX_gRY$5__"